module.exports = __webpack_public_path__ + "static/media/hangbags.7c8d88ae.jpg";